/**
 * 基础菜单 商品管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>学历审核</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true"  ref="formInline" :model="formInline"  class="user-search">
      <el-form-item prop="accountId" label="用户UID">
        <el-input  clearable v-model="formInline.accountId" placeholder="输入用户UID"></el-input>
      </el-form-item>
      <el-form-item prop="nickName" label="用户昵称">
        <el-input  clearable v-model="formInline.nickName" placeholder="输入用户昵称"></el-input>
      </el-form-item>
      <el-form-item prop="sex" label="性别">
    <el-select v-model="formInline.sex" placeholder="不限">
      <el-option label="男" value="1"></el-option>
      <el-option label="女" value="2"></el-option>
    </el-select>
  </el-form-item>
  <el-form-item prop="voucherType" label="认证类型">
    <el-select v-model="formInline.voucherType" placeholder="不限">
      <el-option label="不限" value=""></el-option>
      <el-option label="学信网自助认证" value="1"></el-option>
      <el-option label="提交学信网验证码" value="2"></el-option>
      <el-option label="提交学信网证书编号" value="3"></el-option>
      <el-option label="教留" value="4"></el-option>
      <el-option label="提交学历证书" value="5"></el-option>
    </el-select>
  </el-form-item>

  <el-form-item   prop="operatorUserId" label="审核人员">
        <el-select clearable   v-model="formInline.operatorUserId" placeholder="请选择">
    <el-option

      v-for="item in SelectList"
      :key="item.id"
      :label="item.name"
      :value="item.id">
    </el-option>
  </el-select>
      </el-form-item>
      <el-form-item  prop="beginAge"  label="年龄">

   <el-input  style="width: 80px;" clearable  v-model="formInline.beginAge" placeholder="不限"></el-input>-
   <el-form-item prop="endAge">
     <el-input   style="width: 80px;" prop="endAge" clearable  v-model="formInline.endAge" placeholder="不限"></el-input>
   </el-form-item>
</el-form-item>
<el-form-item prop="beginCreateTime"  label="提交时间">
    <el-col :span="11">
      <el-date-picker  value-format="yyyy-MM-dd HH:mm:ss"    type="datetime" placeholder="选择日期" v-model="formInline.beginCreateTime" style="width: 100%;"></el-date-picker>
    </el-col>
    <el-col class="line" :span="2">&nbsp;&nbsp;&nbsp;&nbsp;-</el-col>
    <el-col :span="11">
        <el-form-item prop="endCreateTime"  label="">
            <el-date-picker   value-format="yyyy-MM-dd HH:mm:ss"    default-time="['23:59:59']"  type="datetime" placeholder="选择日期" v-model="formInline.endCreateTime" style="width: 100%;"></el-date-picker>
        </el-form-item>
    </el-col>
  </el-form-item>
  <el-form-item prop="beginReviewTime"  label="审核时间">
    <el-col :span="11">
      <el-date-picker  value-format="yyyy-MM-dd HH:mm:ss"    type="datetime" placeholder="选择日期" v-model="formInline.beginReviewTime" style="width: 100%;"></el-date-picker>
    </el-col>
    <el-col class="line" :span="2">&nbsp;&nbsp;&nbsp;&nbsp;-</el-col>
    <el-col :span="11">
        <el-form-item prop="endReviewTime"  label="">
            <el-date-picker   value-format="yyyy-MM-dd HH:mm:ss"    default-time="['23:59:59']"  type="datetime" placeholder="选择日期" v-model="formInline.endReviewTime" style="width: 100%;"></el-date-picker>
        </el-form-item>
    </el-col>
  </el-form-item>





<div style=" float: right; margin-right: 50px; margin-bottom: 50px; ">
  <el-button icon="el-icon-circle-check"   type="success"  @click="caozClick">通过</el-button>
  <el-button  icon="el-icon-circle-close" type="warning"  @click="DleClick">拒绝</el-button>
          <el-button  type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button  icon="el-icon-delete"  type="info"    @click="resetForm('formInline')">重置</el-button>

        </div>
    </el-form>


    <el-tabs v-model="activeName" @tab-click="handleClick" style="width: 260px;">
    <el-tab-pane label="待审核" name="1"></el-tab-pane>
    <el-tab-pane label="审核通过" name="2"></el-tab-pane>
    <el-tab-pane label="审核未通过" name="3"></el-tab-pane>

  </el-tabs>
<el-table id="educe-table"  ref="multipleTable"     stripe :data="listData" highlight-current-row v-loading="loading"

  @select-all="selectall"  @select="select" border element-loading-text="拼命加载中" style="width: 100%; font-size: 18px;">
    <el-table-column  @select-all="selectall"  align="center" type="selection" width="60">
    </el-table-column>
    <el-table-column  prop="accountId"   align="center" label="UID" width="150">
      <template slot-scope="scope">
        <img style="width:50%;" v-if="scope.row.isVip==1" src="https://test-cos.ynhlminiapp.com/ae6990bf-1687-4fee-b1c4-f579d5caf927.png" alt=""><br>
        <div style="font-size: 29px; font-weight: 600; color: #9A75E4;">{{scope.row.accountId}}</div>
        <br><img v-if="scope.row.isJoinVipClub==1" style="width: 90px; height: 30px; margin-top: 10px;" src="https://online-miniapp-1304146125.cos.ap-beijing.myqcloud.com/a3c71c1d-165d-4688-9db4-0f63541cab90.png" alt="">
        <br><span v-if="scope.row.isMember==1" style="width: 90px; height: 30px; margin-top: 10px; color: red; font-size: 12px" >线上VIP</span>
        <!-- <div>   {{ new Date(scope.row.registerTime).toLocaleDateString() }}</div> -->
      </template>
    </el-table-column>
    <el-table-column  prop="nickName"   align="center" label="昵称" width="140"/>
    <el-table-column  prop="school"   align="center" label="学校" width="160">
    </el-table-column>
    <el-table-column  prop="major"   align="center" label="专业" width="160">
    </el-table-column>
       <!-- <el-table-column  prop="name"   align="enter" label="姓名" width="100">
    </el-table-column> -->
    <el-table-column  prop="level"   align="center" label="学历" width="100">
    </el-table-column>
    <el-table-column  prop="voucherTypeDesc"   align="center" label="认证类型" width="150">
    </el-table-column>
    <el-table-column  prop="sex"  align="center"  label="图片" width="180">
      <template slot-scope="scope">
        <el-image  v-for="item in scope.row.pictures" :key="index"
      style="width: 60px; height: 60px;  margin-left: 10px; border-radius: 5px;"
      :src="item"
    :preview-src-list="scope.row.pictures"/><br>
      </template>
    </el-table-column>

    <!-- <el-table-column  prop="content"  align="center"  label="图片" width="180">
      <template slot-scope="scope">
        <el-image  v-for="item in scope.row.content" :key="index"
      style="width: 60px; height: 60px;  margin-left: 10px;"
      :src="item"
    :preview-src-list="scope.row.content"/><br>
      </template>
    </el-table-column> -->
    <el-table-column  prop="version" label="提交时间"width="200" >
      <template slot-scope="scope">
        <div>{{scope.row.createTimeMills|timestampToTime}}</div>
      </template>
    </el-table-column>
    <el-table-column  prop="version" label="审核状态" width="140" align="center">
      <template slot-scope="scope">
        <span style="color: #3399FF; font-size: 20px;" v-if="scope.row.status==1">(待审核)</span>
      <span style="color: #34D0B4; font-size: 20px;" v-if="scope.row.status==2">(审核通过)</span>
      <span style="color: #CF1F1F; font-size: 20px;" v-if="scope.row.status==3">(审核不通过)</span>
      </template>
    </el-table-column>

    <el-table-column   prop="headIcon"  align="center" label="头像" width="180">
      <template slot-scope="scope">
        <el-image

      style="width: 130px; height: 130px; border-radius: 5px;"
      :src="scope.row.headIcon?scope.row.headIcon:'https://test-cos.ynhlminiapp.com/accountDefaultHeadIcon.png'"

    :preview-src-list="[scope.row.headIcon]"/>
    <span style="color: #3399FF; font-size: 20px;" v-if="scope.row.headIconStatus==1">(待审核)</span>
      <span style="color: #34D0B4; font-size: 20px;" v-if="scope.row.headIconStatus==2">(审核通过 {{scope.row.appearanceScore||''}}  {{scope.row.appearanceScore?'分':""}})</span>
      <span style="color: #CF1F1F; font-size: 20px;" v-if="scope.row.headIconStatus==3">(审核不通过)</span>
      </template>
    </el-table-column>
    <el-table-column  prop="sex"  align="center"label="性别" width="80">
      <template slot-scope="scope">
        <div :style="scope.row.sex==1?'color: #3399FF':'color:deeppink;'  ">{{scope.row.sex==1?'男':"女"}}</div>
      </template>
    </el-table-column>
    <el-table-column  prop="nickName"   align="center" label="昵称" width="140"/>



    <el-table-column  prop="age"  align="center" label="年龄" width="100">
    </el-table-column>
    <el-table-column  prop="registerAddress"  align="center" label="注册地区" width="100">
    </el-table-column>
    <el-table-column  prop="loginAddress"  align="center" label="登录ip" width="100">
    </el-table-column>
    <el-table-column  align="center"prop="registerTypeDesc" label="注册类型" width="180">
</el-table-column>

    <el-table-column  prop="sourceDesc"  align="center" label="客户来源" width="100">
    </el-table-column>

    <el-table-column  prop="version" label="注册时间" width="250">
      <template slot-scope="scope">
        <div>{{scope.row.registerTimeMills|timestampToTime}}</div>
      </template>
    </el-table-column>

    <el-table-column v-if="activeName==2 ||activeName==3"  prop="operatorUserName" label="审核人" width="100">
    </el-table-column>
    <el-table-column  v-if="activeName==2 ||activeName==3"  prop="version" label="审核时间" width="200" >
      <template slot-scope="scope">
        <div>{{scope.row.operatorTimeMills|timestampToTime}}</div>
      </template>
    </el-table-column>



<!--
    <el-table-column  prop="nickName"   align="center" label="姓名" width="200">
      <template slot-scope="scope">
        <div>{{scope.row.nickName}}</div>
      </template>
    </el-table-column>
    <el-table-column  prop="nickName"   align="center" label="证件类型" width="200">
    </el-table-column>

    <el-table-column  prop="age"  align="center" label="注册类型" width="100">
    </el-table-column>




    <el-table-column  prop="version" label="注册时间" >
      <template slot-scope="scope">
        <div>{{scope.row.submitTime|timestampToTime}}</div>
      </template>
    </el-table-column>
     -->

    <!-- <el-table-column align="center" label="操作" min-width="300">
      <template slot-scope="scope">
        <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
        <el-button size="mini" type="danger" @click="deleteUser(scope.$index, scope.row)">删除</el-button>
      </template>
    </el-table-column> -->
  </el-table>

    <!--列表-->

    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm"   style="float: right; margin-right:0px; height: 50px; margin-top: 50px;"  @size-change="handleSizeChange" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <div style="margin-top: 20px;">
      <el-button v-if="ifShowbar==1" @click="selectalls(listData)" type="primary">全选</el-button>
      <el-button v-if="ifShowbar==2" @click="selectallsif(listData)" type="primary">反选</el-button>
      <!-- <el-button @click="selectalls(listData)" type="primary">全选</el-button> -->


    </div>
    <el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @click="closeDialog">
      <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
        <el-form-item label="部门名称" prop="deptName">
          <el-input  v-model="editForm.deptName" auto-complete="off" placeholder="请输入部门名称"></el-input>
        </el-form-item>
        <el-form-item label="部门代码" prop="deptNo">
          <el-input  v-model="editForm.deptNo" auto-complete="off" placeholder="请输入部门代码"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button  @click="closeDialog">取消</el-button>
        <el-button  type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog
  title="学历认证审核"
  :visible.sync="dialogVisible"
  width="30%"
  >
  <span>是否将该用户的学历认证审核通过？</span>
  <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="OndialogVisible">确 定</el-button>
  </span>
</el-dialog>





</div>
</template>

<script>

import { deptList, deptSave,deptDelete} from '../../api/userMG'
import Axios from 'axios'
import { login } from "../../api"
import Vue from 'vue'


let tokenId= localStorage.getItem('tokenId');

import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
        formInline: {
          isVip:"",
          endReviewTime:"",
          beginReviewTime:"",
        operatorUserId:"",
        ssoServer:"",
        endRegisterTime:"",
        historyHea:"",
        accountId:"",
        registerAddress:'',
        version:"",
        beginCreateTime:"",
        status:1,
        voucherType:"",
        endCreateTime:"",
        education:"",
        registerIpAddress:"",
        beginRegisterTime:"",
        searchType:"",
        source:"",
          sex:'',
        nickName:"",
        phone:"",
        beginAge:"",
        endAge:"",
        current: 1,
        size: 20,
        // token: localStorage.getItem('logintoken')
      },
      dialogVisible: false,
      dialogFormVisibleicn:false,
      ifShowbar:1,
      activeName: '1',
      radio:"",
      dialogFormVisible:false,
      checkList: [],
      options123 : [],
      SelectList:"",
      options1234123:[],

      nshow: true, //switch开启
      fshow: false, //switch关闭
      importList:[],
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '添加',

      editForm: {
        deptId: '',
        deptName: '',
        deptNo: '',
        token: localStorage.getItem('logintoken')
      },

      // rules表单验证
      rules: {
        deptName: [
          { required: true, message: '请输入部门名称', trigger: 'blur' }
        ],
        deptNo: [{ required: true, message: '请输入部门代码', trigger: 'blur' }]
      },

      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      adder:"",
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 20,
        total: 10
      }
    }
  },

  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.ssoServer = Vue.prototype.GLOBAL.ssoServer
    let tokenId= localStorage.getItem('tokenId');
    this.adder =tokenId


    // this.getdata(this.formInline)
  },
   mounted(){
    this.formLIst()

    Axios({
        method: 'get',
        url: this.ssoServer+'/api/platform-user/getSelectList',
        headers:{
          tokenId:this.adder
        },
      }).then(res => {
        if(res.data.code==999){
          setTimeout(() => {
            localStorage.removeItem('tokenId')

            this.$store.commit('logout', 'false')
            this.$router.push({ path: '/login' })
            this.$message({
              type: 'success',
              message: '登录过期,请重新登录'
            })
          }, 1000)
        }
        this.SelectList =res.data.data
        console.log(res);

      })



   },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 确定审核
    OndialogVisible(){
      const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        setTimeout(() => {

          Axios({
        method: 'post',
        url: this.ssoServer+'/api/verified/review',
        headers:{
          tokenId:this.adder
        },
        data:{
        //   appearanceScore:this.radio,

          ids: this.importList,
          verifiedType:2,
          status:2

        }
      }).then(res => {
        if(res.data.code==999){
          setTimeout(() => {
            localStorage.removeItem('tokenId')

            this.$store.commit('logout', 'false')
            this.$router.push({ path: '/login' })
            this.$message({
              type: 'success',
              message: '登录过期,请重新登录'
            })
          }, 1000)
        }
        if(res.data.code==0){
          this.dialogVisible=false
          this.$message({
         type: 'success',
         message: '审核成功'
       })
       this.formInline.current=1
       this.importList=[]
       this.formLIst()
    }
})

          loading.close();
        }, 500);






    },
  // 查看历史图片
  historyHeadIcons(item){
    this.historyHea =item
    // console.log(item);
    this.dialogFormVisibleicn=true

  },
    // 颜值打分
    YZdialogFormVisible(){
      if(!this.radio){
        this.$message({
         type: 'warning',
         message: '选择不能为空'
       })
       return
      }
      Axios({
        method: 'post',
        url: this.ssoServer+'/api/platform-head-icon-check/operate',
        headers:{
          tokenId:this.adder
        },
        data:{
          appearanceScore:this.radio,
          accountIds: this.importList,
          operatorUserId:1,

        }
      }).then(res => {
        if(res.data.code==999){
          setTimeout(() => {
            localStorage.removeItem('tokenId')

            this.$store.commit('logout', 'false')
            this.$router.push({ path: '/login' })
            this.$message({
              type: 'success',
              message: '登录过期,请重新登录'
            })
          }, 1000)
        }
        if(res.data.code==0){
          this.dialogFormVisible=false
          this.$message({
         type: 'success',
         message: '打分成功'
       })

       this.formLIst()
        }
        // // console.log("getAddressList", res.data.data);
        // this.options1234123 = res.data.data

      })

    },
    handleCheckedCitiesChange(){
      console.log(this.checkList);
    },
    caozClick(){
      if(this.importList.length==0){
        this.$message({
         type: 'warning',
         message: '请选择要审核的用户'
       })
       return

      }else{
        this.dialogVisible=true
        console.log('1111');
      }

    },
    DleClick(){
        if(this.importList.length==0){
            this.$message({
         type: 'warning',
         message: '请选择要拒绝审核的用户'
       })
       return
        }
        this.$confirm('是否将该用户的学历认证审核不通过?', '学历认证审核', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        setTimeout(() => {

          Axios({
        method: 'post',
        url: this.ssoServer+'/api/verified/review',
        headers:{
          tokenId:this.adder
        },
        data:{
          ids: this.importList,
          verifiedType:2,
          status:3

        }
      }).then(res => {
        if(res.data.code==999){
          setTimeout(() => {
            localStorage.removeItem('tokenId')
            this.$store.commit('logout', 'false')
            this.$router.push({ path: '/login' })
            this.$message({
              type: 'success',
              message: '登录过期,请重新登录'
            })
          }, 1000)
        }
        if(res.data.code==0){
          this.dialogVisible=false
          this.$message({
         type: 'success',
         message: '拒绝审核成功'
       })

       this.formInline.current=1
       this.importList=[]
       this.formLIst()
    }
    loading.close();
},500)






        },500).catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // });
        });
          loading.close();
        }, 500);



    },

    handleClick(tab, event) {
      this.formInline.current=1
    //  return  console.log(this.activeName);
     if(this.activeName==1){
      this.formInline.status=1
        this.formLIst()
     }else if(this.activeName==2){
      this.formInline.status=2
        this.formLIst()
     }else if(this.activeName==3){
      this.formInline.status=3
        this.formLIst()
     }

      },

    getAddress(){
      Axios({
        method: 'get',
        url: this.ssoServer+'/api/common/getAddressList1',
        headers:{
          tokenId:this.adder
        },
      }).then(res => {
        console.log("getAddressList", res.data.data);
        this.options123 = res.data.data

      })
    },
    getAddresss(){
      Axios({
        method: 'get',
        url: this.ssoServer+'/api/common/getAddressList1',
        headers:{
          tokenId:this.adder
        },
      }).then(res => {
        // console.log("getAddressList", res.data.data);
        this.options1234123 = res.data.data

      })
    },

    change1(e){
      console.log("change1", e);
      if(e.length === 1){
        this.$message({
          type: 'error',
          message: '请选择详细地址'
        })
      }
      if(e.length === 2){
        this.formInline.registerAddress=e[1];
      }
    },
    selectallsif(){
      this.ifShowbar=1
      this.$refs.multipleTable.clearSelection();//清除全选
      this.importList=[]
    },
    selectalls(rows) {
      this.ifShowbar=2
      if (rows) {
        rows.forEach(row => {
            let data =[]
        rows.forEach((item)=>{
        data.push(item.id)
        this.importList =data


      })
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {

        this.$refs.multipleTable.clearSelection();//清除全选
        console.log('2222');

      }
    },


              onChange(e){

                this.formInline.registerAddress=e[1]
                  // console.log( this.formInline.registerAddress);


              },
              onChanges(e){
                this.formInline.registerIpAddress=e[1]
                  // console.log( this.formInline.registerAddress);
              },
    selectall(val){
      let data =[]
      // this.importList=''
      val.forEach((item)=>{
        data.push(item.id)
        this.importList =data


      })

      // this.importList
    console.log(val);
    },
    handleSelectionChange(val) {
        this.multipleSelection = val;
      },
    // 导出数据
    imporList(){
      if(this.importList.length==0){

       this.$message({
         type: 'warning',
         message: '请选择要导出的数据'
       })
       return

     }else{
             Axios({
 method: 'post',

 url: this.ssoServer+'/api/platform-account/exportExcel',
 headers:{
  tokenId:this.adder
        },
 data: {
   accountIds: this.importList
 },
 responseType: 'blob'
}).then(res => {
 const link = document.createElement('a') // 创建a标签
 const blob = new Blob([res.data], { type: 'application/vnd.ms-excel;charset=UTF-8' })
 link.href = window.URL.createObjectURL(blob)
 const filename = res.headers['content-disposition'].split('filename=')[1]
 link.download = decodeURIComponent(filename) // 如果需要自定义下载文件名，则手动设置
 link.click()
 window.URL.revokeObjectURL(link.href)
})


     }




    },
    select(selection, row){
      this.importList=selection

      let data =[]
      // this.importList=''
      selection.forEach((item)=>{
        data.push(item.id)
        this.importList =data
        console.log(this.importList);

      })

      // console.log(this.importList);
      // console.log(selection);
    },
    resetForm(formInline) {
        this.$refs[formInline].resetFields();
      },


    formLIst(){
      // let accountListReqVO= this.formInline
      Axios({
  method: 'get',

  url: this.ssoServer+'/api/verified/getEducationVerifiedList',
  headers:{
    tokenId:this.adder
        },
  params:this.formInline
    // current: this.formInline.current,s
    // size: this.formInline.size,
    // accountListReqVO




}).then(res=>{
  if(res.data.code==999){
          setTimeout(() => {
            localStorage.removeItem('tokenId')

            this.$store.commit('logout', 'false')
            this.$router.push({ path: '/login' })
            this.$message({
              type: 'success',
              message: '登录过期,请重新登录'
            })
          }, 1000)
        }else if(res.data.code==500){
          this.$message({
              type: 'warning',
              message: res.data.message
            })
        }
  this.listData =res.data.data.list

      this.pageparm.currentPage = this.formInline.current
      this.pageparm.pageSize = this.formInline.size
      this.pageparm.total = res.data.data.total
  console.log(res);
})

    },
    formatData(row, column, cellValue, index){

		//把传过来的日期进行回炉重造一下，又创建了一个js的 Date对象，进行重新构造，转为String字符串
		//最终返回 s 就可以了
		var s =	new Date(cellValue).toLocaleString();
	    return s;

		  // 测试参数含义：不知道参数是什么含义的就打印出来
		  // console.log(row)     	//拿到一行的所有信息，要拿到具体信息,只需要row.XXX 就可以了
		  // console.log(column)  	//拿到列的信息
		  // console.log(cellValue) //拿到单元格数据，拿到时间 2022-03-18T01:46:08.000+00:00
		  // console.log(index)     //拿到索引
	    },

    // 获取公司列表
    getdata(parameter) {
      this.loading = true
      // 模拟数据开始
      let res = {
        code: 0,
        msg: null,
        count: 5,
        data: [
          {
            addUser: null,
            editUser: null,
            addTime: 1521062371000,
            editTime: 1526700200000,
            deptId: 2,
            deptName: 'XX分公司',
            deptNo: '1',
            parentId: 1
          },
          {
            addUser: null,
            editUser: null,
            addTime: 1521063247000,
            editTime: 1526652291000,
            deptId: 3,
            deptName: '上海测试',
            deptNo: '02',
            parentId: 1
          },
          {
            addUser: null,
            editUser: null,
            addTime: 1526349555000,
            editTime: 1526349565000,
            deptId: 12,
            deptName: '1',
            deptNo: '11',
            parentId: 1
          },
          {
            addUser: null,
            editUser: null,
            addTime: 1526373178000,
            editTime: 1526373178000,
            deptId: 13,
            deptName: '5',
            deptNo: '5',
            parentId: 1
          },
          {
            addUser: null,
            editUser: null,
            addTime: 1526453107000,
            editTime: 1526453107000,
            deptId: 17,
            deptName: 'v',
            deptNo: 'v',
            parentId: 1
          }
        ]
      }
      this.loading = false

      // 模拟数据结束

      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      deptList(parameter)
        // .then(res => {
        //   console.log(res);
        //   this.loading = false
        //   if (res.success == false) {
        //     this.$message({
        //       type: 'info',
        //       message: res.msg
        //     })
        //   } else {
        //     this.listData = res.data
        //     // 分页赋值
        //     this.pageparm.currentPage = this.formInline.current
        //     this.pageparm.pageSize = this.formInline.size
        //     this.pageparm.total = res.count
        //   }
        // })
        // .catch(err => {
        //   this.loading = false
        //   this.$message.error('菜单加载失败，请稍后再试！')
        // })
    },
    handleSizeChange(e){
      // reru console.log(e.pageSize);
      this.formInline.size =e.pageSize
      this.formInline.current = e.currentPage

      this.formLIst()
    // console.log(e);
    },
    // 分页插件事件
    callFather(parm) {
      console.log(parm);

      this.formInline.size = parm.pageSize
      this.formInline.current = parm.currentPage
      this.formLIst()
    },
    // 搜索事件
    search() {
      this.formInline.current=1
this.formLIst()

      // console.log(this.formInline);
      // this.getdata(this.formInline)
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = '修改'
        this.editForm.deptId = row.deptId
        this.editForm.deptName = row.deptName
        this.editForm.deptNo = row.deptNo
      } else {
        this.title = '添加'
        this.editForm.deptId = ''
        this.editForm.deptName = ''
        this.editForm.deptNo = ''
      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          deptSave(this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.success) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '公司保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('公司保存失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
    },
    // async logins() {
    //     // 网络请求
    //     let data = await login('1111111');
    //     // let token = data.token;
    //     // 本地  vuex
    //     // this.$store.commit('LOGIN_IN',token);
    //     this.$router.replace("/")
    // },

    // 删除公司
    deleteUser(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deptDelete(row.deptId)
            .then(res => {
              if (res.success) {
                this.$message({
                  type: 'success',
                  message: '公司已删除!'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('公司删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false
    }
  }
}
</script>

<style scoped>
.dialogForm{
  width: 100%;
  /* height: 600px; */
  /* background-color: red; */
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  .dialogFormChl{
    margin-top: 20px;
    /* flex: 1; */
    width: 23%;
    border-radius: 15px;
    /* border: 1px solid #ccc; */
    height: 300px;

  }
  .dialogFormChl img{
   width: 100%;
   height: 200px;
  }
}
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>





// WEBPACK FOOTER //
// src/views/system/Degreeauthentication.vue